import { Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { AllChallengesPageContent } from "Components/Loyalty/Shared/Challenges/AllChallenges/AllChallengesPageContent";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { UserInfoGate } from "Components/Shared/UserInfoGate";
import { useHasStardustConsent } from "Hooks/useHasStardustConsent";
import { useIsCurrentUserHunter } from "Hooks/useIsCurrentUserHunter";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { Navigate } from "Navigation/Navigate";

const RESOURCES = Resources.Pages.Content.Loyalty.Challenges;

export const AllChallengesPage = () => {
  const { t } = useResource();
  const { hasStardustConsent } = useHasStardustConsent();
  const isHunter = useIsCurrentUserHunter();

  // Hunters' challenges are Valor (no consent involved); everyone else's are Stardust content
  // (ZS-1624), and without the consent the Stardust page asks for it first. Decided before the
  // layout renders, so not even the page header flashes before the redirect; the gate below still
  // owns the loading and error states of the same query.
  if (!isHunter && hasStardustConsent === false) {
    return <Navigate to={appUrl("stardust")} replace />;
  }

  return (
    <AuthenticatedLayout
      title={t(RESOURCES.AllChallenges.Title)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl(isHunter ? "valor" : "stardust"),
      }}
    >
      <StyledPageWrapper>
        <Stack className="left-content">
          <UserInfoGate>
            <AllChallengesPageContent />
          </UserInfoGate>
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default AllChallengesPage;
